"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLEntityEncoder = void 0;
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const modeNode = FSIServerClientUtils_1.FSIServerClientUtils.GET_MODE_NODE();
class HTMLEntityEncoder {
    constructor() {
        this.entityNode = (modeNode) ? null : window.document.createElement("span");
    }
    encode(str) {
        if (this.entityNode) {
            this.entityNode.innerText = str;
            return this.entityNode.innerHTML;
        }
        else {
            return str;
        }
    }
}
exports.HTMLEntityEncoder = HTMLEntityEncoder;
